export default (): Highcharts.Options => {
    return {
        chart: {
            zooming: {
                type: "xy",
            },
        },
    };
};
